export default import.meta.ROLLDOWN_FILE_URL_N1P2d_0y_wfARkZ2MnXKCA